/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { markupContentStyles, syntaxHighlightStyles } from 'src/styles/markup';

export const ImageWrapper = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: `${gridSize() * 4}px`,
  '> img': {
    alignSelf: 'center',
    border: `1px solid ${token('color.border')}`,
    maxWidth: '100%',
    /* IE11 fix */
    flexShrink: 0,
  },
});

export const MarkupWrapper = styled.div(
  {
    padding: `${gridSize() * 2}px`,
  },
  markupContentStyles,
  syntaxHighlightStyles
);
